// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"e291126d","696":"bc2b533b","768":"c2f3314c","802":"1485c36d"}[chunkId] + ".chunk.css";
};